import { IAppState } from '../common/state';

export const getIsPictureBannerEnabled = (state: IAppState) => state.featureToggle.isPictureBannerEnabled;
